import { computed, type Ref } from 'vue'
import { isNil } from 'lodash-es'

import {
  type LeaveRequestStatus,
  LEAVE_REQUEST_STATUS_LABEL_LOOKUP,
} from '@/constants/leaveRequest'

export { type LeaveRequestStatus } from '@/constants/leaveRequest'
import scssVariables from '@/assets/scss/scssVariables'
import { useComponentClass } from '@thomasaull-shared/composables'

interface Options {
  status: Ref<LeaveRequestStatus | undefined | null>
}

const colors = {
  approved: scssVariables.color['status-leaveRequest-approved'],
  rejected: scssVariables.color['status-leaveRequest-rejected'],
} as const satisfies Partial<Record<LeaveRequestStatus, string>>

export function useLeaveRequestStatus(options: Options) {
  const componentClass = useComponentClass()

  const statusNormalized = computed<LeaveRequestStatus>(() => {
    if (isNil(options.status.value)) return 'notProcessed'
    return options.status.value
  })

  const classes = computed(() => {
    return [
      componentClass.propModifier({
        name: 'status',
        value: statusNormalized.value,
      }),
    ]
  })

  const color = computed(() => {
    return colors[statusNormalized.value]
  })

  const label = computed(() => {
    return LEAVE_REQUEST_STATUS_LABEL_LOOKUP[statusNormalized.value]
  })

  return {
    classes,
    color,
    label,
  }
}
